export const LINK_INFO={
    PRIVACY_LINK:{
        "en" : "https://www.sixt.com/ride/privacy-driver/",
        "de" : "https://www.sixt.de/ride/privacy-driver/",
        "fr" : "https://www.sixt.fr/ride/privacy-driver/",
        "es" : "https://www.sixt.es/ride/privacy-driver/",
        "it" : "https://www.sixt.it/ride/privacy-driver/",
    },

    ANALYTICS_LINK:{
        "en" : "https://www.sixt.com/ride/driverapp-analytics/",
        "de" : "https://www.sixt.de/ride/driverapp-analytics/",
        "fr" : "https://www.sixt.fr/ride/driverapp-analytics/",
        "es" : "https://www.sixt.es/ride/driverapp-analytics/",
        "it" : "https://www.sixt.it/ride/driverapp-analytics/",
    },

    TERMS_OF_SERVICE: {
        en: "https://www.sixt.com/files/ride/tsp/tc_en.pdf",
        de: "https://www.sixt.de/files/ride/tsp/tc_de.pdf",
        fr: "https://www.sixt.fr/files/ride/tsp/tc_fr.pdf",
        es: "https://www.sixt.es/files/ride/tsp/tc_es.pdf",
        it: "https://www.sixt.it/files/ride/tsp/tc_it.pdf",
    },
};
